/**
 * Naming + linking assets in the workspace (mirrors backend/utils/assetAccess.js).
 * An asset is (kind, id): 'manual' (your register), 'anchor' or 'equipment' (tagged on
 * the CloudSafe record). Its key is "manual-12"; its page is /assets/manual/12.
 */
import { appOrigin } from './pdfLinks';

const BASE = '/contractor/workspace';

export const ASSET_KIND_LABEL = { manual: 'Your register', anchor: 'Anchor point', equipment: 'Fixed equipment' };

/** Accept the property record's names too ('anchor_point', 'fixed_equipment'). */
export function normaliseAssetKind(kind) {
  const k = String(kind || '').toLowerCase();
  if (k === 'anchor_point' || k === 'anchor') return 'anchor';
  if (k === 'fixed_equipment' || k === 'equipment') return 'equipment';
  if (k === 'manual') return 'manual';
  return null;
}

export const assetKey = (kind, id) => `${normaliseAssetKind(kind)}-${id}`;

/** In-app route to an asset's page. */
export const assetPath = (kind, id) => `${BASE}/assets/${normaliseAssetKind(kind)}/${encodeURIComponent(id)}`;

/** Absolute deep link — what a QR label carries, so a phone camera opens the asset. */
export const assetDeepLink = (kind, id) => `${appOrigin()}${assetPath(kind, id)}`;

export const TASK_TYPES = [
  ['service', 'Service'], ['inspection', 'Inspection'], ['test', 'Test'],
  ['replace', 'Replace a component'], ['clean', 'Clean'], ['other', 'Other'],
];
export const taskTypeLabel = (t) => (TASK_TYPES.find(([v]) => v === t) || [null, null])[1];

export const intervalLabel = (m) => {
  const n = Number(m);
  const named = { 1: 'Monthly', 3: 'Quarterly', 6: 'Every 6 months', 12: 'Annual', 24: 'Every 2 years', 36: 'Every 3 years', 48: 'Every 4 years', 60: 'Every 5 years' };
  return named[n] || `Every ${n} months`;
};
